import axios from "axios";
import React, { useState, useEffect, useMemo } from "react"
import {useTranslation} from "react-i18next";

function Profile_section(props) {
    const {t, i18n} = useTranslation('common');
    let rem_profile_data = props?.MetaData?.rem_profile_data
    if (rem_profile_data != undefined) {
        try {
            rem_profile_data = JSON.parse(rem_profile_data)
        } catch (e) {
        }
    }
    const [profileData, setProfileData] = useState(rem_profile_data);

    function print_company_description() {
      
            return (
                <div className="content" dangerouslySetInnerHTML={{ __html: window.company_description2 }}></div>
            );
    }
    return (<section class={(props?.MetaData?.rem_profile_enable?.[0] == 'Yes')?'Custom_aligned_main_section rem_nav_section':'Custom_aligned_main_section'} id="profile_section">
        {
            (props?.MetaData?.rem_profile_enable?.[0] == 'Yes') &&
            (<div class="container_size spy_company_description">
                <div class="company_box">
                    
                     <h3>{t('Company Description')}</h3>
                    
                     {(profileData?.description_heading) ? <h3>{profileData?.description_heading}</h3> : ''}
                    {(profileData?.company_description) ?
                        <div class="company_description" id="company_description">
                            {print_company_description()}
                        </div>
                        : ''
                    }
              
                   
                </div>
            </div>)
        }
        {(props?.MetaData?.profile_enable_disable?.[0] == 'Yes') && (
            <section class="section-bg">
                <div class="container_size">
                    {(profileData?.heading) ? <h3 class="text-center">{profileData?.heading}</h3> : ''}
                    <div class="Custom_aligned_main">
                        <div class="Custom_aligned_box">
                            <div class="why_choose_img">
                                {(profileData?.profile?.[0]?.image) ?
                                    <img src={(profileData?.profile?.[0]?.image) ? profileData?.profile?.[0]?.image : ''} alt="" />
                                    : ''
                                }
                            </div>
                            <div class="why_choose_content">
                                {(profileData?.profile?.[0]?.title) ?
                                <h4>{(profileData?.profile?.[0]?.title) ? profileData?.profile?.[0]?.title : ''}</h4>
                                : ''
                            }
                            {(profileData?.profile?.[0]?.info) ?
                                <p>{(profileData?.profile?.[0]?.info) ? profileData?.profile?.[0]?.info : ''}</p>
                                : ''
                            }
                            </div>
                        </div>

                        <div class="Custom_aligned_box">
                        <div class="why_choose_img">
                            {(profileData?.profile?.[1]?.image) ?
                                <img src={(profileData?.profile?.[1]?.image) ? profileData?.profile?.[1]?.image : ''} alt="" />
                                : ''
                            }
                            </div>
                            <div class="why_choose_content">
                            {
                                (profileData?.profile?.[1]?.title) ?
                                    <h4>{(profileData?.profile?.[1]?.title) ? profileData?.profile?.[1]?.title : ''}</h4>
                                    : ''
                            }
                            {
                                (profileData?.profile?.[1]?.info) ?
                                    <p>{(profileData?.profile?.[1]?.info) ? profileData?.profile?.[1]?.info : ''}</p>
                                    : ''
                            }
                            </div>
                        </div>

                        <div class="Custom_aligned_box">
                        <div class="why_choose_img">
                            {
                                (profileData?.profile?.[2]?.image) ?
                                    <img src={(profileData?.profile?.[2]?.image) ? profileData?.profile?.[2]?.image : ''} alt="" />
                                    : ''
                            }
                            </div>
                             <div class="why_choose_content">
                            {
                                (profileData?.profile?.[2]?.title) ?
                                    <h4>{(profileData?.profile?.[2]?.title) ? profileData?.profile?.[2]?.title : ''}</h4>
                                    : ''
                            }
                            {
                                (profileData?.profile?.[2]?.info) ?
                                    <p>{(profileData?.profile?.[2]?.info) ? profileData?.profile?.[2]?.info : ''}</p>
                                    : ''
                            }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )}

    </section>);
}

export default Profile_section;